<template>
  <Modal
    :title="title"
    v-model="visibleDialog"
    width="800px"
    transfer
    class="promoter_person"
    :mask-closable="false"
  >
    <personSelect
      v-if="visibleDialog"
      :list.sync="list"
      :multiple="multiple"
      :selectList.sync="selectList"
      :selectedIds.sync="selectedIds"
      :selectGroupIds.sync="selectGroupIds"
      :originData="originData"
      :customTreeList.sync="customTreeList"
    />
    <span slot="footer" class="dialog-footer">
      <Button @click="$emit('update:visible', false)">取 消</Button>
      <Button type="primary" @click="saveDialog">确 定</Button>
    </span>
  </Modal>
</template>

<script>
import { personSelect } from '@/components/personDepartmentRoleSelect';
import { getMenuTreeByRelationId } from '@/components/personDepartmentRoleSelect/util';
import { getDepartmentAndPerson } from '@/api/workflow';
import { getHasSelectPerson } from '@/api/roleManage';
import util from '@/assets/js/util';
export default {
  components: { personSelect },
  props: ['visible', 'multiple', 'selected', 'roleId', 'roleName'],
  computed: {
    title () {
      return this.roleName ? `选择部门及人员 - ${this.roleName}` : '选择部门及人员';
    }
  },
  data() {
    return {
      visibleDialog: false,
      list: [],
      selectList: [],
      selectedIds: [],
      selectGroupIds: [],
      originData: [],
      customTreeList: [],
      originUserData: [],
      userAuths: []
    };
  },
  methods: {
    saveDialog() {
      this.$emit('change', this.userAuths);
    },
    async getDepartmentAndPersonList(selectedId) {
      const selectGroupIds = [];
      const res = await getDepartmentAndPerson();
      const { code, data } = res.data;
      if (code == 200) {
        const ids = [...selectedId];
        this.selectedIds = ids;
        const { departments, users } = data;
        const userData = users.map(item => {
          const { departmentId, userId, realName, relationId, ...rest } = item;
          return {
            ...rest,
            id: userId,
            title: realName || item.userName,
            pid: departmentId,
            checked: ids.includes(userId),
            isGroup: false,
            groupRelationId: relationId
          };
        });
        const departmentData = departments.map(item => {
          const {
            childDepartmentId,
            childDepartmentName,
            departmentId,
            ...rest
          } = item;
          const currentUsers = userData.filter(
            user => user.pid == childDepartmentId
          );
          const checked =
            currentUsers.length > 0 && currentUsers.every(user => user.checked);
          if (checked) {
            selectGroupIds.push(item.childDepartmentId);
          }
          return {
            ...rest,
            id: childDepartmentId,
            title: childDepartmentName,
            pid: departmentId,
            isGroup: true,
            checked
          };
        });

        const originData = [...departmentData, ...userData];
        const treeData = getMenuTreeByRelationId(originData);
        this.originData = originData;
        this.list = [...treeData];
        const selectList = originData.reduce((pre, next) => {
          const hasId = pre.find(item => item.id == next.id);
          if (selectedId.includes(next.id) && !hasId) {
            pre.push(next);
          }
          return pre;
        }, []);
        this.selectList = [...selectList];
        this.customTreeList = [...treeData];
      }
    },
    getUserAuth() {
      // 获取哪些变化了，
      // 通过原始数据和现在右侧的数据进行对比，把增了的或者减了的给记录下来
      const ids = this.selectList.map(item => item.id);
      // 去重
      const differenceIds = util.getArrDifference(
        [...ids],
        [...this.originUserData]
      );
      const userAuths = differenceIds.map(changeId => ({
        id: changeId,
        authStatus: ids.includes(changeId)
      }));
      this.userAuths = userAuths;
    }
  },
  watch: {
    async visible(val) {
      this.visibleDialog = this.visible;
      if (val) {
        const currentUserId = JSON.parse(localStorage.userInfo).id;
        const res = await getHasSelectPerson({ roleId: this.roleId });
        const { data: roleUsersData, code: roleUsersCode } = res.data;
        if (roleUsersCode == 200) {
          const userRoleUsersData = roleUsersData.filter(
            user => user != currentUserId
          );
          const selected = [...userRoleUsersData];
          this.originUserData = [...userRoleUsersData];
          this.getDepartmentAndPersonList(selected);
        }
      }
    },
    visibleDialog(val) {
      this.$emit('update:visible', val);
    },
    selectList: {
      deep: true,
      handler() {
        this.getUserAuth();
      }
    }
  }
};
</script>

<style></style>
